import { TestQuestion } from "./TestQuestion";
import { TestQuestionList } from "./TestQuestionList";
import Styles from "../TestComponentStyles.module.css";
import { useSearchParams } from "react-router";
import { useEffect, useState } from "react";

import { useTestStore } from "../../../hooks/store";
import { testType } from "../../../utils/testHelper";

export function TestSolvingSection() {
  const [searchParams] = useSearchParams();
  const [questionData, setQuestionData] = useState();
  const testSotre = useTestStore();
  const questionId = searchParams.get("question");
  const { userAnswers, questionList } = testSotre;

  // console.log("получаем набор даннхы для отрисовки теста");
  useEffect(() => {
    testSotre.questionList.find((item, index) => {
      item.id === questionId && setQuestionData(testSotre.questionList[index]);
    });
  }, [questionId]);

  return (
    <div className={Styles.solving_section}>
      <TestQuestionList />
      {questionData && <TestQuestion questionData={questionData} />}
    </div>
  );
}
